import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SForm = styled.form`
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
  & > button {
    margin-left: auto;
    min-width: ${pxToRem(170)}rem;
  }
`

export const STextArea = styled.textarea`
  border: none;
  outline: none;
  font-family: var(--f-text);
  color: var(--c-gray100);
  font-size: 16px;
  line-height: 1.31;
  outline: none;
  cursor: text;
  min-height: ${pxToRem(100)}rem;
  width: 100%;
  resize: vertical;
  @media ${BREAKPOINTS.MD.max} {
    resize: none;
    height: auto;
  }
`

export const SModalMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid var(--c-blue100);
  padding: 1rem;
  transition: all 0.2s;
  &:focus-within {
    border-color: var(--c-blue200);
    box-shadow: 0 0 0 3px var(--c-blue100);
  }
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`

export const SModalMessageLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SQuestionMarkRow = styled.div`
  display: flex;
  justify-content: space-between;

  & > svg {
    cursor: pointer;
    min-width: 1.5rem;
    min-height: 1.5rem;
  }
`
